<template lang="pug">
  v-layout(align-start)
    v-flex
      v-row(justify="center")
        v-btn.ma-1(color='success' dark @click='showActivos = !showActivos')
          | {{ estatusProducto }}
      v-data-table.elevation-1(:headers='headers' item-key='productos' :items='productos' :search='search' sort-by='codigo' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-flex(class="d-flex flex-wrap justify-center")
              v-toolbar-title Productos
              v-divider.mx-4(inset vertical)
              v-spacer
              v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
            v-spacer
            v-btn.mx-2(
              v-if='validarCrear() && showActivos',
              fab,
              dark,
              small,
              color='success',
              @click='dialog = true')
              v-icon(dark) mdi-plus
            ProductoM(:dialog='dialog' :editedIndex='editedIndex' :productos='productos'  @close='close' :read='read' :FormPadre='editedItem' @save='listarProductos' @edited='listarProductos')
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item, true)' v-on="on") mdi-eye
            | Visualizar
          v-tooltip(v-if="item.estatus === 'activo'", bottom)
            template(v-slot:activator='{ on }')
              v-icon.mr-2(v-if='validarModificar()' color='warning' @click='editItem(item)' v-on="on") mdi-pencil
            | Editar
          v-tooltip(v-if="item.estatus === 'activo'" bottom)
            template(v-slot:activator='{ on }')
              v-icon(v-if='validarEliminar()' color='error' @click='deleteItem(item, "inactivo")' v-on="on") mdi-file-remove
            | Desactivar
          v-tooltip(v-else bottom)
            template(v-slot:activator='{ on }')
              v-icon(v-if='validarEliminar()' color='success' @click='activateItem(item, "activo")' v-on="on") mdi-file-restore
            | Activar        
          //- v-icon.mr-2(color='indigo' @click='editItem(item)') mdi-eye
        template(v-slot:no-data)
          h2.pa-2 No hay datos de productos asociados
</template>

<script>
import Api from '@/services/methods'
import ProductoM from '../components/modals/ProductoM'
export default {
  data: () => ({
    dialog: false,
    read: false,
    loading: true,
    headers: [
      { text: 'Codigo', value: 'nombre', align: 'left' },
      { text: 'Descripcion', value: 'descripcion', align: 'center' },
      { text: 'Existencia', value: 'stock', align: 'center' },
      // { text: 'Existencia', value: 'stock', align: 'center' },
      // { text: "Unidad/Medida", value: "unidadMedida", align: "center"  },
      // { text: "Peso", value: "peso" },
      // { text: "Volumen", value: "volumen" },
      { text: 'Costo(Bs)', value: 'costo', align: 'center' },
      { text: 'Precio(Bs)', value: 'precioBs', align: 'center' },
      { text: 'Precio($)', value: 'precio', align: 'center' },
      { text: 'Acciones', value: 'action', sortable: false, align: 'right' }
    ],
    productos: [],
    productosActivos: [],
    productosInactivos: [],
    showActivos: true,
    proBool: false,
    search: '',
    permisosRuta: {},
    editedIndex: -1,
    editedItem: {
      nombre: '',
      descripcion: '',
      upc: '',
      unidadMedida: '',
      stock: '',
      garantia: 0,
      pesoMerma: 0,
      peso: 0,
      volumen: 0,
      alto: 0,
      ancho: 0,
      medidaEmpaque: 0,
      idFabricante: '',
      idMarca: '',
      idLinea: '',
      imagen: {
        imageName: '',
        imageUrl: '',
        imageFile: ''
      }
    },
    defaultItem: {
      nombre: '',
      descripcion: '',
      upc: '',
      unidadMedida: '',
      stock: '',
      garantia: 0,
      pesoMerma: 0,
      peso: 0,
      volumen: 0,
      alto: 0,
      ancho: 0,
      medidaEmpaque: 0,
      idFabricante: '',
      idMarca: '',
      idLinea: '',
      imagen: {
        imageName: '',
        imageUrl: '',
        imageFile: ''
      }
    }
  }),
  components: {
    ProductoM
  },
  computed: {
    /* formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Producto' : 'Modificar Producto'
    }, */
    estatusProducto () {
      return this.showActivos ? 'Mostrar Productos Inactivos' : 'Mostrar Productos activos'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    showActivos (val) {
      if (!val) {
        if (this.productosInactivos.length > 0) this.productos = this.productosInactivos
        else {
          this.productos = []
          this.loading = true
          this.listarProductosInactivos()
          this.loading = false
        }
      } else {
        this.productos = this.productosActivos
      }
    }
  },
  created () {
    this.initialize()
    this.permisosRuta = this.$store.state.empresa[0].permisos.find(
      permiso => permiso.ruta === 'Producto'
    )
  },
  methods: {
    initialize () {
      this.listarProductos()
    },
    listarProductos () {
      Api.get('/producto/all')
        .then(res => {
          console.log(res.data)
          this.productosActivos = [...res.data]
          this.productos = this.productosActivos
          this.productos.map(producto => {
            producto.costo = this.formatoDecimal(producto.costo);
            producto.precio = this.formatoDecimal(producto.precio);
            producto.precioBs = this.formatoDecimal(producto.precioBs)
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },
    listarProductosInactivos () {
      Api.get('/producto/inactivos')
        .then(res => {
          this.productosInactivos = [...res.data]
          this.productos = this.productosInactivos
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },
    formato (fecha) {
      return fecha.substring(0, 10)
    },
    formatoDecimal (i) {
      let n = parseFloat(i).toFixed(2)
      return Number(n).toLocaleString('es', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },

    /* SubLineaSeleccionada(data) {
      console.log( "Seleccionando linea");
      this.idArraySubLinea = [];
      for (let i = 0; i < this.idLineaArray.length; i++) {
        if(data == this.idLineaArray[i].subLinea){
          this.idArraySubLinea.push(this.idLineaArray[i].subLinea)
        }
      }
    }, */

    validarCrear () {
      return this.permisosRuta?.accion.includes('Crear')
    },
    validarModificar () {
      return this.permisosRuta?.accion.includes('Modificar')
    },
    validarEliminar () {
      return this.permisosRuta?.accion.includes('Eliminar')
    },

    editItem (item, bool) {
      // console.log(item)
        this.editedIndex = this.productos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        if (item.codPortafolio) {
          this.editedItem.codPortafolio = item.codPortafolio._id
        }
        if (item.idFabricante) {
          this.editedItem.idFabricante = item.idFabricante._id
        }
        if (item.idLinea) {
          this.editedItem.idLinea = item.idLinea._id
        }
        if (item.idMarca) {
          this.editedItem.idMarca = item.idMarca._id
        }
      setTimeout(() => {
        this.dialog = true
        this.read = bool
      }, 10)
    },

    deleteItem (item, estatus) {
      const index = this.productos.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres desactivar?',
        text: 'Podras activarlo después',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, desactivar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          // this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          Api.put(`/producto/deletelog/${item._id}`)
            .then(res => {
              if (res.data.status === 'denied') {
                this.$swal({
                  icon: 'error',
                  title: 'Error al desactivar',
                  text: res.data.message
                })
              } else {
                item.estatus = "inactivo"
                this.productosActivos.splice(index, 1)
                this.productosInactivos.push(item)
                //this.productos.splice(index, 1)
                this.$swal({
                  icon: 'success',
                  title: 'Desactivación exitosa',
                  //text: 'Todos los datos han sido guardados'
                })
              }
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })        
        }
      })
    },
    activateItem (item, estatus) {
      const index = this.productos.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres activar?',
        //text: 'Podras activarlo después',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, activar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          // this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          Api.put(`/producto/activate/${item._id}`)
            .then(res => {
              if (res.data.status === 'denied') {
                this.$swal({
                  icon: 'error',
                  title: 'Error al activar',
                  text: res.data.message
                })
              } else {
                item.estatus = "activo"
                this.productosInactivos.splice(index, 1)
                this.productosActivos.push(item)
                //this.productos.splice(index, 1)
                this.$swal({
                  icon: 'success',
                  title: 'Activación exitosa',
                  //text: 'Todos los datos han sido guardados'
                })
              }
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })        
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        // this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
      }, 90)
    },
    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    }
  }
}
</script>
